<template>
  <div class="cz-other">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="协议运输单位名录" name="协议运输单位名录">
        <span class="title">协议运输单位名录</span>
        <div class="year-wf">
          <div class="operate-btns" v-auth="'DealWith'">
            <el-button size="mini" @click="add()">添加协议运输单位</el-button>
          </div>
          <!-- 
          <a-table bordered :resizeable="true" :rowKey="(record) => record.id" :pagination="pagination"
            :columns="companyColumns" :data-source="companies" :scroll="{ x: true }" @showSizeChange="onPage" @change="({ current, pageSize }) => {
              onPage(current, pageSize);
            }
              ">
          </a-table> -->

          <el-table
            size="small"
            height="calc(100% - 120px)"
            :header-cell-style="{
              background: '#f5f5f5',
              color: '#000',
              fontWeight: 'blod',
            }"
            :data="companies"
            style="width: 100%; margin-bottom: 20px"
            row-key="id"
            border
          >
            <el-table-column align="center" label="序号" width="60">
              <template scope="scope">
                <span>{{
                  (pagination.current - 1) * pagination.pageSize +
                  scope.$index +
                  1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="companyName" label="企业名称">
            </el-table-column>
            <el-table-column
              align="center"
              prop="licenseNo"
              label="道路运输经营许可证编号"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="businessScope"
              label="经营范围"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="licenseDateTime"
              label="证件有效期"
            >
              <template slot-scope="{ row }">
                {{
                  $dayjs(row.startLicense).format("YYYY-MM-DD") +
                  "至" +
                  $dayjs(row.endLicense).format("YYYY-MM-DD")
                }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="protocolDateTime"
              label="协议服务期限"
            >
              <template slot-scope="{ row }">
                {{
                  $dayjs(row.startProtocol).format("YYYY-MM-DD") +
                  "至" +
                  $dayjs(row.endProtocol).format("YYYY-MM-DD")
                }}
              </template>
            </el-table-column>
          </el-table>
          <div class="paaination">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.current"
              :page-sizes="pagination.pageSizeOptions"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="佐证材料" name="second">
        <span class="title">佐证材料</span>
        <div class="file-list">
          <el-radio-group v-model="tabs" size="small" @change="tabChange(tabs)">
            <el-radio-button label="危险废物经营许可资质"></el-radio-button>
            <el-radio-button label="协议运输单位合同"></el-radio-button>
            <el-radio-button label="协议运输单位资质"></el-radio-button>
          </el-radio-group>
          <keep-alive>
            <component v-bind:is="tabView" style="width: 100%; height: 100%">
            </component>
          </keep-alive>
        </div>
      </el-tab-pane>
    </el-tabs>
    <addTransportCompany
      ref="addTransportCompany"
      :dealWithCompanies="dealWithCompanies"
    >
    </addTransportCompany>
  </div>
</template>

<script>
import { paginations } from "@/../utils/public";

import addTransportCompany from "./components/addTransportCompany.vue";
import dangerWasterLicenseFiles from "./components/dangerWasterLicenseFiles.vue";
import protocolCompanyZiZhiFiles from "./components/protocolCompanyZiZhiFiles.vue";
import protocolCompanyContractFiles from "./components/protocolCompanyContractFiles.vue";
export default {
  components: {
    addTransportCompany,
    dangerWasterLicenseFiles,
    protocolCompanyZiZhiFiles,
    protocolCompanyContractFiles,
  },
  data() {
    const companyColumns = [
      {
        title: "序号",
        align: "center",
        width: 70,
        customRender: (text, record, index) => {
          const { current, pageSize } = this.pagination;
          return (current - 1) * pageSize + index + 1;
        },
      },
      {
        title: "企业名称",
        dataIndex: "companyName",
        key: "companyName",
        align: "center",
      },
      {
        title: "道路运输经营许可证编号",
        dataIndex: "licenseNo",
        key: "licenseNo",
        align: "center",
      },
      {
        title: "经营范围",
        dataIndex: "businessScope",
        key: "code",
        align: "center",
      },
      {
        title: "证件有效期",
        dataIndex: "licenseDateTime",
        key: "licenseDateTime",
        align: "center",
        customRender: (text, record, index) => {
          return (
            this.$dayjs(record.startLicense).format("YYYY-MM-DD") +
            " 至 " +
            this.$dayjs(record.endLicense).format("YYYY-MM-DD")
          );
        },
      },
      {
        title: "协议服务期限",
        dataIndex: "protocolDateTime",
        key: "protocolDateTime",
        align: "center",
        customRender: (text, record, index) => {
          return (
            this.$dayjs(record.startProtocol).format("YYYY-MM-DD") +
            " 至 " +
            this.$dayjs(record.endProtocol).format("YYYY-MM-DD")
          );
        },
      },
    ];
    return {
      activeName: "协议运输单位名录",
      companyColumns,
      companies: [],
      handleType: [],
      // companyId: 0,
      pagination: {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      },
      // pagination: {
      //   current: paginations.page,
      //   pageSize: paginations.limit,
      //   total: paginations.total,
      //   showSizeChanger: true,
      //   hideOnSinglePage: false,
      //   showQuickJumper: true,
      //   pageSizeOptions: paginations.pageSizesOption,
      //   showTotal: (total) => `一共${total}条记录 `,
      // },
      wfList: [],
      dealWithCompanies: [],
      tabs: "危险废物经营许可资质",
      tabView: "dangerWasterLicenseFiles",
    };
  },
  props: {
    companyId: {
      default: 0,
    },
  },
  watch: {
    companyId(val) {
      this.getAllData();
    },
  },
  computed: {},
  methods: {
    tabChange(tab) {
      switch (tab) {
        case "危险废物经营许可资质":
          this.tabView = "dangerWasterLicenseFiles";
          break;
        case "协议运输单位合同":
          this.tabView = "protocolCompanyZiZhiFiles";
          break;
        case "协议运输单位资质":
          this.tabView = "protocolCompanyContractFiles";
          break;
      }
    },
    getOtherCompanies() {
      const params = {
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        getTotal: true,
      };
      if (this.companyId) params.companyId = this.companyId;
      let url = this.$api.transportCompanies.getList;
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let { companies, total } = res.data.data;
          this.companies = companies;
          this.pagination.total = total;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    //添加
    add() {
      this.$refs.addTransportCompany.lookUserDrawerOpen();
    },
    edit(row) {
      this.$refs.addTransportCompany.lookUserDrawerOpen(row);
    },
    // 分页切换方法

    onPage(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getOtherCompanies();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getOtherCompanies();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getOtherCompanies();
    },
    deleteDw(id) {
      this.$confirm("此操作将永久删除此项, 是否继续?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let url = this.$api.dangerWasters.delete + "/" + id;
        this.$axios.del(url, false).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getOtherCompanies();
          } else {
            this.$message({
              message: "加载数据失败，请重试",
              type: "error",
            });
          }
        });
      });
    },
  },
  mounted() {
    // this.companyId = this.$route.params.companyId

    this.getOtherCompanies();
  },
};
</script>

<style lang="scss" scoped>
.cz-other {
  width: 100%;
  height: 100%;
  // color: #000;

  .el-tabs {
    width: 100%;
    height: 100%;

    /deep/.el-tabs__content {
      height: calc(100% - 55px);

      .el-tab-pane {
        height: 100%;
      }
    }
  }
}

.paaination {
  text-align: right;
}

.year-wf {
  height: calc(100% - 33px);
  padding: 0px 50px 10px 50px;

  /deep/.ant-table td {
    white-space: nowrap;
  }
}

.file-list {
  padding: 10px 50px;
  height: calc(100% - 28px);
}

.dialog-form {
  padding: 0px 20px;
}

.operate-btns {
  margin: 5px 0px;
}

.title {
  font-size: 18px;
  font-weight: bold;
  border-left: 8px solid #1890ff;
  padding-left: 12px;
  color: #000;
}
</style> 